// // src/redux/setupAxios.js - FIXED WITH PROACTIVE REFRESH
// import { refreshToken } from "../app/modules/Auth/_redux/authCrud";
// import * as auth_actions from "../app/modules/Auth/_redux/authRedux";
// import createAuthRefreshInterceptor from 'axios-auth-refresh';
// import config from "../config";
// import { googleLogout } from '@react-oauth/google';


// // ✅ CRITICAL: Single refresh state manager
// let isRefreshing = false;
// let refreshPromise = null;

// export default function setupAxios(axios, store) {
//   axios.defaults.baseURL = config.URL;

//   // ✅ Check if token is about to expire (within 5 minutes)
//   const isTokenExpiringSoon = (token) => {
//     if (!token) return true;
    
//     try {
//       const base64Url = token.split('.')[1];
//       const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//       const jsonPayload = decodeURIComponent(
//         atob(base64)
//           .split('')
//           .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
//           .join('')
//       );
      
//       const { exp } = JSON.parse(jsonPayload);
//       const expiryTime = exp * 1000;
//       const now = Date.now();
//       const fiveMinutes = 5 * 60 * 1000;
      
//       return (expiryTime - now) < fiveMinutes;
//     } catch (error) {
//       console.error('Error decoding token:', error);
//       return true;
//     }
//   };

//   // ✅ Centralized token refresh function
//   const performTokenRefresh = async (currentRefreshToken) => {
//     if (!currentRefreshToken) {
//       throw new Error('No refresh token available');
//     }

//     // ✅ If already refreshing, return the existing promise
//     if (isRefreshing && refreshPromise) {
//       return refreshPromise;
//     }

//     isRefreshing = true;
    
//     refreshPromise = refreshToken(currentRefreshToken)
//       .then((response) => {
//         const data = response.data;
        
//         if (!data.access || !data.refresh) {
//           throw new Error('Invalid token response');
//         }
        
//         // Update tokens in Redux
//         store.dispatch(
//           auth_actions.actions.fulfillToken(
//             data.access.token,
//             data.refresh.token
//           )
//         );
        
//         // console.log('✅ Token refresh successful');
//         return data.access.token;
//       })
//       .catch((error) => {
//         console.error('❌ Token refresh failed:', error);
//         store.dispatch(auth_actions.actions.logout());
//         googleLogout();
//         throw error;
//       })
//       .finally(() => {
//         isRefreshing = false;
//         refreshPromise = null;
//       });

//     return refreshPromise;
//   };



//   // ✅ REQUEST INTERCEPTOR
//   axios.interceptors.request.use(
//     async (requestConfig) => {
//       const state = store.getState();
//       let { authToken } = state.auth;
//       const { refreshToken: currentRefreshToken } = state.auth;

//       // Skip token refresh for auth endpoints
//       const excludedEndpoints = [
//         '/auth/login',
//         '/auth/register',
//         '/auth/refresh-tokens',
//         '/auth/forgot-password',
//         '/auth/reset-password',
//         '/auth/verify-email',
//       ];

//       const isExcluded = excludedEndpoints.some(endpoint => 
//         requestConfig.url?.includes(endpoint)
//       );

//       // ✅ PROACTIVE REFRESH: Check if token is expiring soon
//       if (!isExcluded && authToken && isTokenExpiringSoon(authToken) && currentRefreshToken) {
//         // console.log('🔄 Token expiring soon, proactively refreshing...');
        
//         try {
//           const newToken = await performTokenRefresh(currentRefreshToken);
//           authToken = newToken;
//           // console.log('✅ Proactive refresh complete, using new token');
//         } catch (error) {
//           console.error('❌ Proactive refresh failed');
//           throw error;
//         }
//       }

//       // Add auth token to request
//       if (authToken) {
//         requestConfig.headers.Authorization = `Bearer ${authToken}`;
//       }

//       // Auto-add organization_id if needed (your existing logic - commented out for now)
//       // if (organization?.organization_id && needsOrganizationId(requestConfig.url)) {
//       //   const orgId = organization.organization_id;
        
//       //   // For GET requests, add to query params ONLY if not already present
//       //   if (requestConfig.method === 'get') {
//       //     requestConfig.params = requestConfig.params || {};
          
//       //     // Only add if organization_id doesn't exist at all
//       //     if (!requestConfig.params.organization_id) {
//       //       requestConfig.params.organization_id = orgId;
//       //     }
//       //   } 
//       //   // For POST/PUT/PATCH, add to body ONLY if not already present
//       //   else if (['post', 'put', 'patch'].includes(requestConfig.method)) {
//       //     if (requestConfig.data && typeof requestConfig.data === 'object' && !Array.isArray(requestConfig.data)) {
//       //       // Check if it's FormData
//       //       if (requestConfig.data instanceof FormData) {
//       //         if (!requestConfig.data.has('organization_id')) {
//       //           requestConfig.data.append('organization_id', orgId);
//       //         }
//       //       } else {
//       //         // Only add if organization_id doesn't exist
//       //         if (!requestConfig.data.organization_id) {
//       //           requestConfig.data = {
//       //             ...requestConfig.data,
//       //             organization_id: orgId,
//       //           };
//       //         }
//       //       }
//       //     }
//       //   }
//       // }

//       return requestConfig;
//     },
//     (error) => Promise.reject(error)
//   );

//   // ✅ REFRESH LOGIC FOR 401 ERRORS
//   const refreshAuthLogic = async (failedRequest) => {
//     const requestUrl = failedRequest.response?.config?.url || '';
    
//     // Don't refresh for auth endpoints
//     const excludedEndpoints = [
//       '/auth/login',
//       '/auth/register',
//       '/auth/refresh-tokens',
//       '/auth/forgot-password',
//       '/auth/reset-password',
//       '/auth/verify-email',
//     ];

//     if (excludedEndpoints.some(endpoint => requestUrl.includes(endpoint))) {
//       return Promise.reject(failedRequest);
//     }

//     const state = store.getState();
//     const currentRefreshToken = state.auth.refreshToken;
    
//     if (!currentRefreshToken) {
//       console.log('❌ No refresh token available, logging out');
//       store.dispatch(auth_actions.actions.logout());
//       googleLogout();
//       return Promise.reject(failedRequest);
//     }

//     console.log('🔄 401 error, starting token refresh...');

//     try {
//       // Perform refresh (will reuse existing promise if already refreshing)
//       const newToken = await performTokenRefresh(currentRefreshToken);
      
//       // ✅ CRITICAL: Update the failed request with new token
//       failedRequest.response.config.headers['Authorization'] = `Bearer ${newToken}`;
      
//       console.log('✅ Token refreshed, request will be retried');
//       return Promise.resolve();
//     } catch (error) {
//       console.error('❌ Refresh failed, logging out');
//       return Promise.reject(error);
//     }
//   };

//   // ✅ Configure axios-auth-refresh
//   createAuthRefreshInterceptor(axios, refreshAuthLogic, {
//     statusCodes: [401],
//     pauseInstanceWhileRefreshing: true,
//   });

//   // ✅ RESPONSE INTERCEPTOR: Better error logging
//   axios.interceptors.response.use(
//     (response) => response,
//     (error) => {
//       const status = error.response?.status;
//       const url = error.config?.url || '';
      
//       // Log errors for debugging (except 401 which is handled by refresh logic)
//       if (status && status !== 401) {
//         console.log(`❌ API Error ${status}: ${url}`);
//       }
      
//       return Promise.reject(error);
//     }
//   );
// }




// src/redux/setupAxios.js
import { refreshToken } from "../app/modules/Auth/_redux/authCrud";
import * as auth_actions from "../app/modules/Auth/_redux/authRedux";
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import config from "../config";
import { googleLogout } from '@react-oauth/google';


// ✅ CRITICAL: Single refresh state manager
let isRefreshing = false;
let refreshPromise = null;

export default function setupAxios(axios, store) {
  axios.defaults.baseURL = config.URL;

  // ✅ Check if token is about to expire (within 5 minutes)
  const isTokenExpiringSoon = (token) => {
    if (!token) return true;
    
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      
      const { exp } = JSON.parse(jsonPayload);
      const expiryTime = exp * 1000;
      const now = Date.now();
      const fiveMinutes = 5 * 60 * 1000;
      
      return (expiryTime - now) < fiveMinutes;
    } catch (error) {
      console.error('Error decoding token:', error);
      return true;
    }
  };

  // ✅ Centralized token refresh function
  const performTokenRefresh = async (currentRefreshToken) => {
    if (!currentRefreshToken) {
      throw new Error('No refresh token available');
    }

    // ✅ If already refreshing, return the existing promise
    if (isRefreshing && refreshPromise) {
      return refreshPromise;
    }

    isRefreshing = true;
    
    refreshPromise = refreshToken(currentRefreshToken)
      .then((response) => {
        const data = response.data;
        
        if (!data.access || !data.refresh) {
          throw new Error('Invalid token response');
        }
        
        store.dispatch(
          auth_actions.actions.fulfillToken(
            data.access.token,
            data.refresh.token
          )
        );
        
        return data.access.token;
      })
      .catch((error) => {
        console.error('❌ Token refresh failed:', error);
        store.dispatch(auth_actions.actions.logout());
        googleLogout();
        throw error;
      })
      .finally(() => {
        isRefreshing = false;
        refreshPromise = null;
      });

    return refreshPromise;
  };



  // ✅ REQUEST INTERCEPTOR
  axios.interceptors.request.use(
    async (requestConfig) => {
      const state = store.getState();
      let { authToken } = state.auth;
      const { refreshToken: currentRefreshToken } = state.auth;

      const excludedEndpoints = [
        '/auth/login',
        '/auth/register',
        '/auth/refresh-tokens',
        '/auth/forgot-password',
        '/auth/reset-password',
        '/auth/verify-email',
      ];

      const isExcluded = excludedEndpoints.some(endpoint => 
        requestConfig.url?.includes(endpoint)
      );

      // ✅ PROACTIVE REFRESH: Check if token is expiring soon
      if (!isExcluded && authToken && isTokenExpiringSoon(authToken) && currentRefreshToken) {
        try {
          const newToken = await performTokenRefresh(currentRefreshToken);
          authToken = newToken;
        } catch (error) {
          console.error('❌ Proactive refresh failed');
          throw error;
        }
      }

      if (authToken) {
        requestConfig.headers.Authorization = `Bearer ${authToken}`;
      }

      return requestConfig;
    },
    (error) => Promise.reject(error)
  );

  // ✅ REFRESH LOGIC FOR 401 ERRORS
  const refreshAuthLogic = async (failedRequest) => {
    const requestUrl = failedRequest.response?.config?.url || '';
    
    const excludedEndpoints = [
      '/auth/login',
      '/auth/register',
      '/auth/refresh-tokens',
      '/auth/forgot-password',
      '/auth/reset-password',
      '/auth/verify-email',
    ];

    if (excludedEndpoints.some(endpoint => requestUrl.includes(endpoint))) {
      return Promise.reject(failedRequest);
    }

    const state = store.getState();
    const currentRefreshToken = state.auth.refreshToken;
    
    if (!currentRefreshToken) {
      console.log('❌ No refresh token available, logging out');
      store.dispatch(auth_actions.actions.logout());
      googleLogout();
      return Promise.reject(failedRequest);
    }

    try {
      const newToken = await performTokenRefresh(currentRefreshToken);
      failedRequest.response.config.headers['Authorization'] = `Bearer ${newToken}`;
      return Promise.resolve();
    } catch (error) {
      console.error('❌ Refresh failed, logging out');
      return Promise.reject(error);
    }
  };

  // ✅ Configure axios-auth-refresh
  createAuthRefreshInterceptor(axios, refreshAuthLogic, {
    statusCodes: [401],
    pauseInstanceWhileRefreshing: true,
  });

  // ✅ RESPONSE INTERCEPTOR
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;
      const url    = error.config?.url || '';

      if (status === 402) {
        // Subscription suspended or cancelled — redirect to blocked page.
        // Guard against redirect loops (e.g. the billing page itself firing a 402).
        if (!window.location.pathname.startsWith('/subscription-blocked')) {
          window.location.href = '/subscription-blocked';
        }
        return Promise.reject(error);
      }

      // Log all non-401 errors (401 is handled by the refresh interceptor above)
      if (status && status !== 401) {
        console.log(`❌ API Error ${status}: ${url}`);
      }

      return Promise.reject(error);
    }
  );
}